/* istanbul ignore file */
export * from './ProductListPageLayout';
